import * as core from '../../../../../../../core'
import * as researchType from '../research-type'

export const RESOURCE = {
  payload: {
    description: 'Internal Funding',
    enumId: core.dms.models.Enum.Id.from({
      partialId: researchType.RESOURCE.payload.partialId,
    }),
    id: 'INTERNAL FUNDING',
    name: 'Internal Funding',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
